// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".design[data-v-18a2c36b]{padding:16px;width:656px;height:280px;background:#3e3e3f;box-shadow:0 12px 16px rgba(0,0,0,.4);border-radius:8px}.design-content[data-v-18a2c36b]{display:flex}", ""]);
// Exports
module.exports = exports;
